import { FC, useEffect, useRef, useState } from "react";
import { format } from "date-fns";

import { Table } from "antd";

import { IExaminationDataValue } from "@/models/ExaminationDataValue";
import formatExaminationDataValue from "@/utils/formatExaminationDataValue";

interface ReportTableProps {
  data: IExaminationDataValue[];
  isAutoScroll?: boolean;
}

const columns = [
  {
    title: "Time",
    dataIndex: "Time",
    key: "Time",
    render: (time: string) => <span>{format(new Date(time), "HH:mm:ss")}</span>,
  },
  {
    title: "T⁰inh",
    dataIndex: "Tinh",
    key: "Tinh",
  },
  {
    title: "T⁰exh",
    dataIndex: "Texh",
    key: "Texh",
  },
  {
    title: "Rinh",
    dataIndex: "Rinh",
    key: "Rinh",
  },
  {
    title: "Rexh",
    dataIndex: "Rexh",
    key: "Rexh",
  },
  {
    title: "Rsum",
    dataIndex: "Rsum",
    key: "Rsum",
  },
  {
    title: "%CO₂inh",
    dataIndex: "%CO2inh",
    key: "%CO2inh",
  },
  {
    title: "%CO₂avg",
    dataIndex: "%CO2avg",
    key: "%CO2avg",
  },
  {
    title: "%CO₂exh",
    dataIndex: "%CO2exh",
    key: "%CO2exh",
  },
  {
    title: "%O₂inh",
    dataIndex: "%O2inh",
    key: "%O2inh",
  },
  {
    title: "Extr.V",
    dataIndex: "Extr.V",
    key: "Extr.V",
  },
  {
    title: "Extr. T⁰",
    dataIndex: "Extr.T",
    key: "Extr.T",
  },
  {
    title: "CO₂V",
    dataIndex: "CO2V",
    key: "CO2V",
  },
  {
    title: "Vent.V",
    dataIndex: "Vent.V",
    key: "Vent.V",
  },
  {
    title: "Vent.T⁰",
    dataIndex: "Vent.T",
    key: "Vent.T",
  },
];

const ReportTable: FC<ReportTableProps> = ({
  data,
  isAutoScroll = false,
}) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (tableRef.current && isAutoScroll) {
      const page = Math.ceil(data.length / 100) || 1;
      if (page !== currentPage) {
        setCurrentPage(page);
      }
      const table = tableRef.current.querySelector(".ant-table-body");
      table?.scrollTo(0, Number(table.scrollHeight));
    }
  }, [data, isAutoScroll]);

  const preparedData = data.map((rep) => ({
    ...formatExaminationDataValue(rep),
    key: rep.Time,
  }));

  const handleChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <Table
      ref={tableRef}
      sticky
      size="small"
      pagination={{
        showSizeChanger: false,
        pageSize: 100,
        current: currentPage,
        onChange: handleChange,
      }}
      scroll={{ y: window.innerHeight }}
      columns={columns}
      dataSource={preparedData}
    />
  );
};

export default ReportTable;
